import { render, staticRenderFns } from "./ProviderGreetingWidget.vue?vue&type=template&id=357a6335&scoped=true&"
import script from "./ProviderGreetingWidget.vue?vue&type=script&lang=js&"
export * from "./ProviderGreetingWidget.vue?vue&type=script&lang=js&"
import style0 from "./ProviderGreetingWidget.vue?vue&type=style&index=0&id=357a6335&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357a6335",
  null
  
)

export default component.exports